import React from 'react';
interface PhoneFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}
export function PhoneField({
  label,
  value,
  onChange,
  required = false
}: PhoneFieldProps) {
  const formatPhone = (val: string) => {
    const cleaned = val.replace(/\D/g, '');
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  };
  const handleChange = (rawValue: string) => {
    const cleaned = rawValue.replace(/\D/g, '');
    onChange(cleaned);
  };
  return <div className="flex flex-col gap-1.5" data-id="element-28">
      <label className="text-sm font-medium text-gray-700" data-id="element-29">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-30">*</span>}
      </label>
      <input type="tel" value={formatPhone(value)} onChange={e => handleChange(e.target.value)} placeholder="(555) 555-5555" required={required} className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" data-id="element-31" />
    </div>;
}